import { usePlansQuery } from '@/api/queries/plan';
import AccountSubscriptionPlanForm from '@/components/forms/AccountFactory/AccountSubscriptionPlanForm';
import { Grid } from '@mui/material';
import { useOperatorsActivePlansQuery, useOperatorsQuery } from 'api/queries/operators';
import { useTranslation } from 'react-i18next';

function SettingsSubscriptionDetailsView() {
  const { data: operatorDetails, isSuccess: isOperatorSuccess } = useOperatorsQuery();
  const { data, isSuccess } = useOperatorsActivePlansQuery();
  const { data: plans, isSuccess: isPlansSuccess } = usePlansQuery();
  const { i18n } = useTranslation();

  if (!isSuccess || !isPlansSuccess || !isOperatorSuccess) return null;

  return (
    <Grid container spacing={4}>
      <Grid item xs={12} md='auto'>
        <AccountSubscriptionPlanForm
          plans={plans.elements}
          defaultValues={{
            billingFrequency: data.billingFrequency,
            planId: data.plan?.id,
            email: operatorDetails.contactEmail,
            phoneNumber: operatorDetails.contactPhoneNumber,
            name: operatorDetails.name,
            lang: i18n.language,
            message: '',
          }}
        />
      </Grid>
    </Grid>
  );
}

export default SettingsSubscriptionDetailsView;
